'use client';

import { c as _c } from "react/compiler-runtime";
import { isEnumValue } from '@core/utils';
import { useSearchParams } from 'next/navigation';
import { PageNavigation } from '@/components/client';
import { useAuthStore } from '@/stores/AuthStore';
import { CustomPolicyFilter } from './_components/CustomPolicyFilter';
import { FILTER_PAGE, FilterTab } from './_components/FilterTab';
import { InterestedPolicyFilter } from './_components/InterestedPolicyFilter';
const MyInfoFilterPage = () => {
  const $ = _c(18);
  const nickName = useAuthStore(_temp);
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    const pageSearchParams = searchParams.get("page");
    t0 = isEnumValue(FILTER_PAGE, pageSearchParams) ? pageSearchParams : FILTER_PAGE.BASIC;
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const page = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <PageNavigation title={"\uB0B4 \uB9DE\uCDA4 \uC815\uBCF4"} />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== page) {
    t2 = <FilterTab filterPage={page} />;
    $[3] = page;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== nickName) {
    t3 = <header className="my-40 flex-col gap-8 px-20"><h2 className="font-600 text-Gray-black typo-h6">{nickName}님에 대해 알려주세요</h2><p className="font-400 text-Gray-800 typo-body3">{nickName}님에게 딱 맞는 정책을 추천해드릴게요!</p></header>;
    $[5] = nickName;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <CustomPolicyFilter />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3) {
    t5 = <>{t3}{t4}</>;
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <h2 className="mb-8 font-600 text-Gray-black typo-body1">평소 관심있는 것을 알려주세요</h2>;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <br />;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <><header className="mx-20 my-40">{t6}<p className="font-400 text-Gray-800 typo-body3">관심 기반으로 추천해드리며{t7}설정에서 변경할 수 있어요<span className="ml-4 text-Gray-600 typo-body4">(중복선택 가능)</span></p></header><InterestedPolicyFilter /></>;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t5) {
    t9 = {
      [FILTER_PAGE.BASIC]: t5,
      [FILTER_PAGE.INTEREST]: t8
    };
    $[13] = t5;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const t10 = t9[page];
  let t11;
  if ($[15] !== t10 || $[16] !== t2) {
    t11 = <article className="mx-auto w-full max-w-screen-xl pb-[calc(140px+var(--safe-area-bottom,0px))]">{t1}{t2}{t10}</article>;
    $[15] = t10;
    $[16] = t2;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  return t11;
};
export default MyInfoFilterPage;
function _temp(state) {
  return state.myInfo?.nickName;
}